"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _BrightcovePlayer = _interopRequireDefault(require("../../BrightcovePlayer/BrightcovePlayer.player"));

var _Modal = _interopRequireDefault(require("../../Modal/Modal.index"));

var _Gallery = _interopRequireDefault(require("../Gallery.image"));

var _Gallery2 = require("../Gallery.types");

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs.index"));

var _Thumbnails = _interopRequireDefault(require("../Thumbnails/Thumbnails.index"));

var _Modal2 = require("./Modal.styles");

var _excluded = ["thumbnail", "image"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var allTab = {
  label: 'All',
  value: 'MIXED'
};
var photoTab = {
  label: 'Photos',
  value: 'IMAGE'
};
var videoTab = {
  label: 'Videos',
  value: 'VIDEO'
};

var GalleryModal = function GalleryModal(_ref) {
  var images = _ref.images,
      initialIndex = _ref.initialIndex,
      initialState = _ref.initialState,
      isOpen = _ref.isOpen,
      loadedImages = _ref.loadedImages,
      onClose = _ref.onClose,
      productInfo = _ref.productInfo,
      setLoadedImages = _ref.setLoadedImages,
      theme = _ref.theme,
      videos = _ref.videos,
      videoPlayerProps = _ref.videoPlayerProps;

  var _ref2 = theme !== null && theme !== void 0 ? theme : {},
      _ref2$gallery = _ref2.gallery;

  _ref2$gallery = _ref2$gallery === void 0 ? {} : _ref2$gallery;
  var _ref2$gallery$modalTa = _ref2$gallery.modalTabs,
      modalTabs = _ref2$gallery$modalTa === void 0 ? 'none' : _ref2$gallery$modalTa,
      _ref2$gallery$modal = _ref2$gallery.modal;
  _ref2$gallery$modal = _ref2$gallery$modal === void 0 ? {} : _ref2$gallery$modal;
  var modalThumbnail = _ref2$gallery$modal.thumbnail,
      modalImage = _ref2$gallery$modal.image,
      rest = (0, _objectWithoutProperties2["default"])(_ref2$gallery$modal, _excluded),
      _ref2$gallery$showTit = _ref2$gallery.showTitle,
      showTitle = _ref2$gallery$showTit === void 0 ? false : _ref2$gallery$showTit,
      thumbnail = _ref2$gallery.thumbnail,
      modal = _ref2.modal,
      image = _ref2.image;

  var _useState = (0, _react.useState)(initialState !== null && initialState !== void 0 ? initialState : modalTabs === 'all' ? 'MIXED' : 'IMAGE'),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      viewState = _useState2[0],
      setViewState = _useState2[1];

  var _useState3 = (0, _react.useState)(initialIndex !== null && initialIndex !== void 0 ? initialIndex : 0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var selectItem = function selectItem(selectedIndex) {
    setActiveIndex(selectedIndex);

    if (viewState !== 'VIDEO' && activeIndex < images.length && !loadedImages.includes(selectedIndex)) {
      setLoadedImages([].concat((0, _toConsumableArray2["default"])(loadedImages), [selectedIndex]));
    }
  };

  var onChangeTab = function onChangeTab(view) {
    setViewState(view);
    selectItem(0);
  };

  var showTabs = modalTabs !== 'none' && videos.length && images.length;
  var tabContent = modalTabs === 'all' ? [allTab, photoTab, videoTab] : [photoTab, videoTab];
  var activeType = viewState === 'VIDEO' || activeIndex >= images.length ? 'VIDEO' : 'IMAGE';
  var adjustedIndex = viewState === 'MIXED' && activeType === 'VIDEO' ? activeIndex - images.length : activeIndex;
  var activeContent = activeType === 'VIDEO' ? videos[adjustedIndex] : images[adjustedIndex];
  var totalLength = (viewState !== 'VIDEO' ? images.length : 0) + (viewState !== 'IMAGE' ? videos.length : 0);
  var title = "".concat(adjustedIndex + 1, " of ").concat(totalLength);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    theme: {
      modal: _objectSpread(_objectSpread({}, modal), rest)
    },
    width: "90vw",
    height: "90vh",
    title: showTitle ? title : undefined,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Modal2.GalleryModalContent, {
    className: "gcc-app"
  }, /*#__PURE__*/_react["default"].createElement(_Modal2.Media, null, activeType === 'VIDEO' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, activeContent.description && /*#__PURE__*/_react["default"].createElement(_Modal2.VideoTitle, {
    theme: theme
  }, activeContent.description), /*#__PURE__*/_react["default"].createElement(_BrightcovePlayer["default"], (0, _extends2["default"])({
    videoId: activeContent.videoId
  }, videoPlayerProps, {
    classNames: ['video-player']
  }))), activeType === 'IMAGE' && /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
    image: activeContent,
    productInfo: productInfo,
    showDescription: true,
    isLoaded: loadedImages.includes(adjustedIndex),
    theme: {
      gallery: {
        image: _objectSpread(_objectSpread({}, image), modalImage)
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_Modal2.ThumbnailContainer, null, showTabs && /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    options: tabContent,
    selected: viewState,
    onChange: onChangeTab,
    theme: theme,
    name: "gcc-product-gallery-modal-type"
  }), /*#__PURE__*/_react["default"].createElement(_Thumbnails["default"], {
    images: images,
    videos: videos,
    mode: viewState,
    activeIndex: activeIndex,
    onThumbnailClick: selectItem,
    onThumbnailHover: _noop2["default"],
    limit: false,
    theme: {
      gallery: {
        thumbnail: _objectSpread(_objectSpread({}, thumbnail), modalThumbnail)
      }
    }
  }))));
};

GalleryModal.propTypes = {
  images: _propTypes["default"].arrayOf(_Gallery2.imageShape),
  videos: _propTypes["default"].arrayOf(_Gallery2.videoShape),
  productInfo: _Gallery2.productInfoShape,
  theme: _Gallery2.galleryTheme,
  initialState: _propTypes["default"].string,
  initialIndex: _propTypes["default"].number,
  isOpen: _propTypes["default"].bool,
  loadedImages: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onClose: _propTypes["default"].func,
  setLoadedImages: _propTypes["default"].func,
  videoPlayerProps: _Gallery2.videoPlayerShape
};
GalleryModal.defaultProps = {
  videos: [],
  images: [],
  productInfo: {},
  theme: undefined,
  initialState: undefined,
  initialIndex: undefined,
  isOpen: false,
  loadedImages: [],
  onClose: _noop2["default"],
  setLoadedImages: _noop2["default"],
  videoPlayerProps: undefined
};
GalleryModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GalleryModal",
  "props": {
    "videos": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "videoShape"
        }
      },
      "required": false
    },
    "images": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "imageShape"
        }
      },
      "required": false
    },
    "productInfo": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "productInfoShape"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "galleryTheme"
      },
      "required": false
    },
    "initialState": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "initialIndex": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "isOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "loadedImages": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false
    },
    "onClose": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "setLoadedImages": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "videoPlayerProps": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "videoPlayerShape"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(GalleryModal);

exports["default"] = _default;